import { render, staticRenderFns } from "./TruckButton.vue?vue&type=template&id=7ca525c4"
import script from "./TruckButton.vue?vue&type=script&lang=js"
export * from "./TruckButton.vue?vue&type=script&lang=js"
import style0 from "./TruckButton.vue?vue&type=style&index=0&id=7ca525c4&prod&lang=css"
import style1 from "./TruckButton.vue?vue&type=style&index=1&id=7ca525c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports